import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import VacancyCard from "@/components/VacancyCard";
import ShareModal from "@/components/ShareModal";
import { ArrowLeft, BarChart3 } from "lucide-react";

export default function VacancyDetail() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [stats, setStats] = useState(null);
  const [share, setShare] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/vacancies/${id}`).then(({ data }) => setV(data));
    api.get(`/stats/vacancy/${id}`).then(({ data }) => setStats(data)).catch(() => {});
  }, [id]);

  if (!v) return <div className="text-[var(--ink-soft)]">A carregar…</div>;

  return (
    <div className="space-y-6">
      <Link to="/vacancies" className="pill-btn pill-ghost !py-2 !px-3 w-fit"><ArrowLeft className="w-4 h-4"/> Voltar</Link>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <VacancyCard v={v} onRecommend={() => navigate(`/recommend/${v.id}`)} onShare={() => setShare(v)} showShare/>
        </div>
        {stats && (
          <div className="card-surface p-6">
            <div className="flex items-center gap-2 eyebrow"><BarChart3 className="w-4 h-4"/> Estatísticas</div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Visualizações</div><div className="font-heading text-2xl">{stats.views}</div></div>
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Cliques</div><div className="font-heading text-2xl">{stats.clicks}</div></div>
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Partilhas</div><div className="font-heading text-2xl">{stats.shares}</div></div>
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Recomendações</div><div className="font-heading text-2xl">{stats.recommendations}</div></div>
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Entrevistas</div><div className="font-heading text-2xl">{stats.interviews}</div></div>
              <div className="p-3 rounded-xl bg-[var(--muted)]"><div className="text-xs text-[var(--ink-soft)]">Contratações</div><div className="font-heading text-2xl">{stats.hires}</div></div>
            </div>
            <div className="mt-4 p-3 rounded-xl bg-[rgba(217,108,74,0.08)] border border-[rgba(217,108,74,0.2)]">
              <div className="text-xs eyebrow !text-[var(--terracotta)]">Taxa conversão rec.→contratação</div>
              <div className="font-heading text-2xl text-[var(--terracotta)]">{(stats.conv_rec_to_hire * 100).toFixed(1)}%</div>
            </div>
          </div>
        )}
      </div>
      {share && <ShareModal vacancy={share} onClose={() => setShare(null)}/>}
    </div>
  );
}
